import React from 'react';

import { formatCount, formatDateTime, formatRequestId } from '../utils/format';

function ratioEntries(ratios) {
  return Object.entries(ratios || {}).filter((entry) => Number(entry[1]) > 0);
}

function labelize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export default function ReportsPanel({ downloadingId, loading, onDownload, reports }) {
  return (
    <aside className="panel reports-panel">
      <div className="panel__header">
        <div>
          <span className="panel__eyebrow">Report library</span>
          <h2>Saved reports</h2>
          <p>Every generated workbook stays available here for direct Excel download.</p>
        </div>
      </div>

      {loading ? <div className="empty-state">Loading saved reports...</div> : null}

      {!loading && reports.length === 0 ? (
        <div className="empty-state">No reports yet. Generate your first workbook from the form.</div>
      ) : null}

      {!loading && reports.length > 0 ? (
        <div className="report-list">
          {reports.map((report) => {
            const ratios = ratioEntries(report.ratios);
            const isDownloading = downloadingId === report.id;

            return (
              <article className="report-card" key={report.id}>
                <div className="report-card__top">
                  <div>
                    <h3>{report.filename || 'Generated report'}</h3>
                    <p>{formatRequestId(report.id)}</p>
                  </div>

                  <button className="button button--ghost" disabled={isDownloading} onClick={() => onDownload(report)} type="button">
                    {isDownloading ? 'Downloading...' : 'Download'}
                  </button>
                </div>

                <div className="report-card__meta">
                  <span>{formatCount(report.count)} rows</span>
                  <span>{report.rate || 0} msg/sec</span>
                  <span>{formatDateTime(report.createdAt)}</span>
                </div>

                <div className="report-card__ratios">
                  {ratios.length > 0 ? ratios.map(([key, value]) => (
                    <span className="ratio-tag" key={key}>
                      {labelize(key)} {value}
                    </span>
                  )) : <span className="muted-text">Default sent ratio</span>}
                </div>
              </article>
            );
          })}
        </div>
      ) : null}
    </aside>
  );
}
